export default __webpack_public_path__ + "static/media/bar-graph-border-right.1a5a06f6.svg";